import React, { useState, useEffect, forwardRef } from 'react';
import { PanelTopWrapper } from 'components';
import './modal-phone.scss';
import * as yup from 'yup';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, Label, Input } from 'reactstrap';
import { InputValidation, PostContactService, GetUniquePhone, UpdatePhoneService } from 'services';
import { formatPhone } from 'helpers';

const ReactstrapInputWrapper = forwardRef((props, ref) => {
  return <Input {...props} innerRef={ref} />;
});

export function ModalPhone({ modalClass, idStore, update, openModal, toggleModalPhone, phoneEdit = '' }) {
  const URL_NEW_REGISTER = 'new';

  const populateObject = (invalid, message) => {
    return {
      invalid,
      message,
    };
  };

  const [phone, setPhone] = useState(populateObject(false, ''));

  const phoneSchema = yup.object().shape({
    phone: yup
      .string()
      .matches(/^(\(\d{2}\) (9?\d{4})-\d{4})|((\(1[2-9]{1}\)|\([2-9]{1}\d{1}\)) [5-9]\d{3}-\d{4})$/)
      .required(),
  });

  const phoneFormData = {
    phone: phone.value,
    idStore: idStore,
  };

  const chooseAction = () => {
    phoneEdit === URL_NEW_REGISTER
      ? PostContactService(phoneFormData).then(() => {
          update();
          toggleModalPhone();
        })
      : UpdatePhoneService(phoneEdit, phone.value).then(() => {
          update();
          toggleModalPhone();
        });

    resetPhone();
  };

  const getPopulateObject = (input, value) => {
    const inputs = {
      phone: () => {
        setPhone(populateObject(true, value));
      },
    };

    return inputs[input] ? inputs[input]() : chooseAction();
  };

  useEffect(() => {
    if (phoneEdit !== URL_NEW_REGISTER && phoneEdit) {
      GetUniquePhone(phoneEdit).then((phone) => {
        setPhone({ value: phone.phoneNumber });
      });
    } else if (phoneEdit === URL_NEW_REGISTER) resetPhone();
  }, [phoneEdit, openModal]);

  const getValidation = async () => {
    const feedback = await Promise.resolve(
      InputValidation({
        schema: phoneSchema,
        formdata: phoneFormData,
      })
    ).then((value) => value);

    if (feedback?.id) {
      return feedback.id.forEach((element, index) => {
        getPopulateObject(element, feedback.error[index]);
      });
    }

    return getPopulateObject(feedback?.id);
  };

  const resetPhone = () => {
    setPhone({ value: '' });
  };

  const prepareOpenModal = () => {
    resetPhone();
    toggleModalPhone();
  };

  function onChangePhone(e) {
    const formattedPhone = formatPhone(e.target.value);

    setPhone({ value: formattedPhone });
  }

  return (
    <div>
      <Modal isOpen={openModal} toggle={prepareOpenModal} className={modalClass}>
        <ModalHeader toggle={prepareOpenModal}> Telefone </ModalHeader>
        <ModalBody>
          <Label>Telefone</Label>

          <ReactstrapInputWrapper placeholder="(99) 99999-9999" value={phone.value} invalid={phone.invalid} onChange={onChangePhone} />

          <FormFeedback> {phone.message} </FormFeedback>
        </ModalBody>

        <ModalFooter>
          <PanelTopWrapper padding={'py-4'}>
            <Button color="secundary" onClick={prepareOpenModal}>
              Cancelar
            </Button>
            <Button color="primary" onClick={getValidation}>
              Salvar
            </Button>
          </PanelTopWrapper>
        </ModalFooter>
      </Modal>
    </div>
  );
}
